import { render, staticRenderFns } from "./templateForm.vue?vue&type=template&id=4a5b139c&scoped=true&"
import script from "./templateForm.vue?vue&type=script&lang=js&"
export * from "./templateForm.vue?vue&type=script&lang=js&"
import style0 from "./templateForm.vue?vue&type=style&index=0&id=4a5b139c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5b139c",
  null
  
)

export default component.exports